module.exports = __webpack_public_path__ + "static/media/pagey-sitting.2ca1d0e6.png";